import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const CallingIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Calling",
    children: /*#__PURE__*/_jsx("path", {
      d: "m3.68 4.3 1.63-1.63C5.73 2.25 6.3 2 6.94 2s1.21.26 1.63.67l4.36 4.36c.42.42.68 1 .68 1.63s-.26 1.22-.68 1.63l-3.18 3.18c-.28.28-.46.67-.46 1.09s.17.81.46 1.09l6.55 6.55a1.543 1.543 0 0 0 2.18 0l3.18-3.18c.42-.42 1-.68 1.63-.68s1.22.26 1.63.68l4.38 4.37c.42.42.68 1 .68 1.63s-.26 1.22-.68 1.63l-1.65 1.63c-1.74 1.74-4.56 2.12-7.77 1.22-1.18-.33-2.2-.71-3.17-1.18l.11.05a27.8 27.8 0 0 1-7.72-5.54 28 28 0 0 1-5.47-7.57l-.07-.16c-.23-.47-.42-.93-.61-1.41-1.45-3.86-1.34-7.38.7-9.42Z"
    })
  }));
};